<template>
  <div class="layer-tree" @click="handleSubmitEdit()">
    <el-tree ref="layerTree" 
      :filter-node-method="handleFilterNode"
      :data="treeData" 
      show-checkbox 
      node-key="id" 
      :props="defaultProps"
      default-expand-all
      :expand-on-click-node="false"
      draggable
      @node-contextmenu="handleTreeContextmenu" 
      @node-click="handleNodeClick" 
      @check-change="handleNodeCheckChange" 
      >
      <template #default="{ node, data }">
        <el-input 
            v-if="data.id === editorId"
            size='mini'
            v-model="data.name"
            style="height:20px line-height:20px"
            clearable
            @blur="() => handleSubmitEdit(node,data)">
          </el-input>
        <span v-else class="custom-tree-node">
            <span>{{ node.label }}</span>
            <span>
              <slot name="layerOperate" :data="data" :node="node" :tree="tree" />
            </span>
        </span>
      </template>
  </el-tree>
</div>
</template>

<script>
import { getsche } from "@/api/layer.js"
export default {
  name: 'LayerTree',
  components: {},
  props:{
    addLayer:{
      type:Function,
      default:null
    },
    removeLayer:{
      type:Function,
      default:null
    },
    editorId:{
      type:String,
      default:''
    }
  },
  computed:{
    tree:{
      get(){
        return this.$refs.layerTree
      }
    }
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      settingForm:{
         alpha: 100,
         layer:''
      },
      checkedKeys:[],//选中的节点
      halfCheckedKeys:[],//默认展开
      currentSchemId:null,
    };
  },

  mounted() {
    
  },
  beforeDestroy() {
    this.clearMap()
  },
  methods: {
    loadData(data){
      const {treeData,checkedKeys} = data
      this.treeData = treeData ||[];
      this.clearMap()
      if (this.tree) {
        this.tree.setCheckedKeys(checkedKeys || [])
        this.$nextTick().then(() => {
          this.tree.getCheckedNodes().forEach(nodeData => {
            this.handleNodeCheckChange(nodeData,true)
          })
        });
      }
    },
    clearData(){
      this.treeData=[]
    },
    addData(arr){
      const array = Array.isArray(arr)?arr:[arr]
      if (!this.treeData) {
        this.treeData = []
      }
      this.index_ = 0
      array.forEach((item)=>{
        this.refreshId(item,0)
        this.treeData.push(item)
      })
    },
    handleSubmitEdit(){
      this.$emit('update:editorId','')
    },
    handleFilterNode(value, data){
      //过滤节点
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleNodeClick(data){
      //图层节点点击事件
      this.$emit("node-click",data)
    },
    handleNodeCheckChange(data, checked){
      //图层节点复选框发生变化事件
      if (data.url) {
        this.$emit('layer-changed',data,checked)
      }
    },
    handleTreeContextmenu(event,data,node){
      this.$emit("node-contextmenu",event,data,node)
    },
    clearMap(){
      this.$emit('clear-map')
    },
    loadSchemConfig(schemName){
      console.log("loadSchemConfig",schemName);
      this.currentSchem = null
      //加载方案图层配置
      const tree =  this.$refs.layerTree
      if (tree && schemName) {
        getsche({programName:schemName}).then ((res) => {
          this.currentSchem =  res.data.data[0]
          const { forest, checkedKeys } = this.currentSchem
          const treeData = JSON.parse(forest)
          this.loadData({treeData,checkedKeys:JSON.parse(checkedKeys)})
        }) 
      }
    },

    getTreeData(){
      return this.treeData
    },
    getCheckedKeys(){
      return this.tree?this.tree.getCheckedKeys():[]
    },
    getHalfCheckedKeys(){
      return this.tree?this.tree.getHalfCheckedKeys():[]
    },
    getCheckedLayers(){
      const layers = this.tree?this.tree.getCheckedNodes()||[]:[]
      return layers.filter((lyr)=>lyr.url)
    },
    loseBlur(event){
      event.target.blur()
    },
    refreshId(node,parentId=0){
      const id = new Date().getTime() + this.index_.toString() 
      node.id = id
      node.parentId = parentId
      if(node.children){
        node.children.forEach(child=>{
          this.index_ = this.index_ + 1
          this.refreshId(child,id)
        })
      }
    }
  },
};
</script>
<style scoped>
.layer-tree {
  height: 100%;
  padding: 15px;
  min-height: 200px;
  overflow: auto;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

</style>